"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.cognitoUserPoolTransferHandler = void 0;
var cognitoUserPoolTransferHandler_1 = require("./cognitoUserPoolTransferHandler");
Object.defineProperty(exports, "cognitoUserPoolTransferHandler", { enumerable: true, get: function () { return cognitoUserPoolTransferHandler_1.cognitoUserPoolTransferHandler; } });
